import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useMaybePolicy } from '../application/product/policy/policyContext'
import { useMaybeProposal } from '../application/product/proposal/proposalContext'
import { getContentBaseUrl, useConfig } from '../state/configuration'

export const useNavigateCallback = (...paths: string[]) => {
  const navigate = useNavigate()
  const path = paths.join('/')
  return useCallback(() => navigate(path), [navigate, path])
}

export const useHelpLink = (name: string) => {
  const baseUrl = useConfig(getContentBaseUrl)
  const proposal = useMaybeProposal()
  const policy = useMaybePolicy()

  const { schemeCode } = proposal ?? policy ?? {}

  return [baseUrl, schemeCode, 'questions', `${name}.html`].filter(Boolean).join('/')
}
